export default "__VITE_ASSET__DjHCwLCS__"